var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepIco3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0848 15C15.9349 15 15 15.9496 15 17.1176V29.8235C15 30.9915 15.9349 31.9412 17.0848 31.9412H21.8472L22.2023 30.1379C22.3424 29.4199 22.6909 28.7614 23.1991 28.2452L27.5055 23.871V20.6449C27.5055 20.0824 27.2872 19.543 26.8963 19.146L23.4271 15.6187C23.0362 15.2217 22.5052 15 21.9547 15H17.0848ZM25.6031 20.8235H22.5573C22.1241 20.8235 21.7756 20.4695 21.7756 20.0294V16.9357L25.6031 20.8235ZM23.7366 30.4489L23.3489 32.421C23.3424 32.4507 23.3391 32.4838 23.3391 32.5169C23.3391 32.7816 23.5509 33 23.8147 33C23.8473 33 23.8766 32.9967 23.9092 32.9901L25.8507 32.5963C26.2546 32.5136 26.6259 32.3118 26.9158 32.0173L30.789 28.0831L28.183 25.436L24.3099 29.3702C24.02 29.6647 23.8212 30.0419 23.7398 30.4522L23.7366 30.4489ZM32.4601 26.379C33.18 25.6478 33.18 24.4632 32.4601 23.732C31.7402 23.0007 30.574 23.0007 29.8541 23.732L28.9159 24.6849L31.5219 27.332L32.4601 26.379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIco3);
export default __webpack_public_path__ + "static/media/Step_ico_3.66deaadd158b9ba02edfd32cee282eb2.svg";
export { ForwardRef as ReactComponent };